import { Group, Image } from 'react-konva';
import React, { useState, useEffect } from 'react';
import { scheduleLoadImage } from '@shakkerai/pro-utils';

export const VideoElement = React.memo(({ element }) => {
  const { width, height, coverUrl } = element;
  const [image, setImage] = useState(null);

  useEffect(() => {
    scheduleLoadImage(coverUrl).then(setImage);
  }, [coverUrl]);

  return (
    <Group>
      <Image
        name={element.id}
        id={element.id + '-video'}
        role="element"
        roleType="video"
        image={image}
        fill={image ? undefined : '#b3dbd830'}
        imageUrl={coverUrl}
        width={width}
        height={height}
      />
    </Group>
  );
});
